(function ($, app, api) {
	app.getCurrentOrder = function (data) {
        var deferred = new $.Deferred();
        if (app.cookie.get('b') === '0') {
			return deferred.resolve({}).promise();
		}
		return api.getPublicCurrentOrder({ imageSize: 200, deliveryDetails: { Postcode: null, PickupPoint: null } });
	};
	app.currentOrder = app.getCurrentOrder(50);
})(jQuery, app, api);
